(() => {
  if (window.mlBookWaitlistsBound) return;
  window.mlBookWaitlistsBound = true;
  let opener;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-waitlist-open]');
    if (trigger) {
      const dialogs = [...document.querySelectorAll('dialog.ml-book-waitlist')];
      const dialog = trigger.dataset.waitlistBook
        ? dialogs.find(d => d.dataset.book === trigger.dataset.waitlistBook)
        : dialogs.length === 1 ? dialogs[0] : null;
      if (!dialog) return;
      opener = trigger;
      dialog.showModal();
      return;
    }
    const close = event.target.closest('.ml-book-waitlist-close');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.ml-book-waitlist')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('dialog.ml-book-waitlist')) opener?.focus();
  }, true);
})();
